//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum AddQuoteSupportRequestState {
  Created = 0,
  DuplicateRequest = 1
}

export interface Address {
  line1: string;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export interface AllSupplierSettings {
  settings: SupplierSettings;
  purchaseOrderRecipients: PurchaseOrderRecipientLibrary;
  pricingRules: PricingRuleLibrary;
}

export interface BaseLogin {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  systemUserId: string;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
  claims: { [key: string]: string } | null;
}

export interface ConnectedState {
  connected: boolean;
}

export enum ConversationState {
  Resolved = 0,
  Cancelled = 1,
  ReActivated = 2
}

export enum CurrencyCode {
  ALL = 8,
  DZD = 12,
  ARS = 32,
  AUD = 36,
  BSD = 44,
  BHD = 48,
  BDT = 50,
  AMD = 51,
  BBD = 52,
  BMD = 60,
  BTN = 64,
  BOB = 68,
  BWP = 72,
  BZD = 84,
  SBD = 90,
  BND = 96,
  MMK = 104,
  BIF = 108,
  KHR = 116,
  CAD = 124,
  CVE = 132,
  KYD = 136,
  LKR = 144,
  CLP = 152,
  CNY = 156,
  COP = 170,
  KMF = 174,
  CRC = 188,
  HRK = 191,
  CUP = 192,
  CZK = 203,
  DKK = 208,
  DOP = 214,
  SVC = 222,
  ETB = 230,
  ERN = 232,
  FKP = 238,
  FJD = 242,
  DJF = 262,
  GMD = 270,
  GIP = 292,
  GTQ = 320,
  GNF = 324,
  GYD = 328,
  HTG = 332,
  HNL = 340,
  HKD = 344,
  HUF = 348,
  ISK = 352,
  INR = 356,
  IDR = 360,
  IRR = 364,
  IQD = 368,
  ILS = 376,
  JMD = 388,
  JPY = 392,
  KZT = 398,
  JOD = 400,
  KES = 404,
  KPW = 408,
  KRW = 410,
  KWD = 414,
  KGS = 417,
  LAK = 418,
  LBP = 422,
  LSL = 426,
  LRD = 430,
  LYD = 434,
  MOP = 446,
  MWK = 454,
  MYR = 458,
  MVR = 462,
  MUR = 480,
  MXN = 484,
  MNT = 496,
  MDL = 498,
  MAD = 504,
  OMR = 512,
  NAD = 516,
  NPR = 524,
  ANG = 532,
  AWG = 533,
  VUV = 548,
  NZD = 554,
  NIO = 558,
  NGN = 566,
  NOK = 578,
  PKR = 586,
  PAB = 590,
  PGK = 598,
  PYG = 600,
  PEN = 604,
  PHP = 608,
  QAR = 634,
  RUB = 643,
  RWF = 646,
  SHP = 654,
  SAR = 682,
  SCR = 690,
  SLL = 694,
  SGD = 702,
  VND = 704,
  SOS = 706,
  ZAR = 710,
  SSP = 728,
  SZL = 748,
  SEK = 752,
  CHF = 756,
  SYP = 760,
  THB = 764,
  TOP = 776,
  TTD = 780,
  AED = 784,
  TND = 788,
  UGX = 800,
  MKD = 807,
  EGP = 818,
  GBP = 826,
  TZS = 834,
  USD = 840,
  UYU = 858,
  UZS = 860,
  WST = 882,
  YER = 886,
  TWD = 901,
  SLE = 925,
  VES = 928,
  MRU = 929,
  STN = 930,
  ZWL = 932,
  BYN = 933,
  TMT = 934,
  GHS = 936,
  SDG = 938,
  RSD = 941,
  MZN = 943,
  AZN = 944,
  RON = 946,
  TRY = 949,
  XAF = 950,
  XCD = 951,
  XOF = 952,
  XPF = 953,
  XBA = 955,
  XBB = 956,
  XBC = 957,
  XBD = 958,
  XAU = 959,
  XDR = 960,
  XAG = 961,
  XPT = 962,
  XTS = 963,
  XPD = 964,
  XUA = 965,
  ZMW = 967,
  SRD = 968,
  MGA = 969,
  AFN = 971,
  TJS = 972,
  AOA = 973,
  BGN = 975,
  CDF = 976,
  BAM = 977,
  EUR = 978,
  UAH = 980,
  GEL = 981,
  PLN = 985,
  BRL = 986,
  XSU = 994,
  XXX = 999
}

export interface DealerDeployment {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  active: boolean;
  deploymentType: DeploymentType;
  securityAccessToken: string | null;
  name: string | null;
  comment: string | null;
  apiDomain: string | null;
  otherApiDomains: { [key: string]: string } | null;
  uiDomain: string | null;
  deploymentLicenceeId: number;
  azureBlobConnectionString: string | null;
  azureBlobDomain: string | null;
  systemType: DealerDeploymentSystemType;
  operationType: DealerDeploymentOperationType;
  secrets: { [key: string]: any } | null;
}

export enum DealerDeploymentOperationType {
  Production = 0,
  Test = 1,
  Development = 2
}

export enum DealerDeploymentSystemType {
  V6 = 0,
  V7 = 1
}

export interface DealerProblemDetails {}

export interface DeploymentFranchiseeBranch {
  dateCreated: string;
  id: string;
  recordVersion: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  taxRegistrationNumber: string | null;
  abbreviation: string;
  name: string;
  physicalAddress: Address;
  billingAddress: Address | null;
  physicalAddressAsDefaultShipping: boolean;
}

export interface DeploymentFranchiseeConfiguration {
  dateCreated: string;
  id: string;
  recordVersion: string;
  globalSupplierReferenceId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  defaultPricingRuleId: string;
  fabricatorModeEnabled: boolean;
}

export interface DeploymentTenantLicensePool {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  name: string | null;
  concurrentUsers: number;
  dateExpires: string;
  dealerDeploymentId: number;
  dealerDeployment: DealerDeployment | null;
  licenseOwnerType: LicenseOwnerType;
  licenseOwnerName: string | null;
  licenseOwnerId: number;
}

export enum DeploymentType {
  SingleSupplierOwnerOperator = 0,
  SingleSupplierManaged = 2,
  MultiSupplierManaged = 4,
  SupplierInterface = 8,
  SingleSupplierInterface = 16,
  LicenseServer = 32
}

export interface GlobalSupplierReference {
  dateCreated: string;
  id: string;
  recordVersion: string;
  supplierTenantId: number;
  licenseServerId: number;
}

export interface InputAddQuoteSupportRequest {
  status: SupportInboxItemStatus | null;
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  quoteId: string;
  quoteSetId: string;
  franchiseeSystemUserId: string;
  type: SupportInboxItemType;
  conversationId: string;
  subject: string;
  note: string | null;
  other: { [key: string]: string };
}

export interface InputCopyFileItem {
  originalVirtualPath: string;
  copyVirtualPath: string;
}

export interface InputCopyFilesByVirtualPath {
  copyData: InputCopyFileItem[];
}

export interface InputCreateFranchisee {
  requestOnBoardTenant: RequestOnBoardTenant;
  defaultPricingRuleId: string;
  fabricatorModeEnabled: boolean;
}

export interface InputCreateTerritory {
  territoryName: string;
}

export interface InputDeleteFileItem {
  virtualPath: string;
}

export interface InputDeleteFilesByVirtualPath {
  fileItems: InputDeleteFileItem[];
}

export interface InputDeleteSupplierImages {
  settings: SupplierSettings;
  deletePositiveLogo: boolean;
  deleteNegativeLogo: boolean;
  deleteResourceLogo: boolean;
}

export interface InputDeleteTerritory {
  id: string;
}

export interface InputFranchiseeBranch {
  dateCreated: string | null;
  branchId: string;
  taxRegistrationNumber: string | null;
  name: string;
  abbreviation: string;
  physicalAddress: Address;
  billingAddress: Address | null;
  physicalAddressAsDefaultShipping: boolean;
}

export interface InputGetCoreSupplierSettings {}

export interface InputLinkFranchiseeBranchToTerritory {
  branchIds: string[];
  territoryId: string;
}

export interface InputSetNewQuotesAndPurchaseOrdersForSupplier {
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  deploymentId: number;
  quotes: QuoteDTO[];
  purchaseOrders: PurchaseOrderDTO[];
}

export interface InputSyncBranches {
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  deploymentId: number;
  branches: InputFranchiseeBranch[];
}

export interface InputUnlinkFranchiseeBranchFromTerritory {
  territoryFranchiseeBranchLinks: TerritoryFranchiseeBranchLink[];
}

export interface InputUpdateCoreSupplierSettings {
  settings: SupplierSettings;
  purchaseOrderRecipients: PurchaseOrderRecipientLibrary | null;
  pricingRules: PricingRuleLibrary | null;
  base64PositiveLogo: string | null;
  positiveLogoFileName: string | null;
  base64NegativeLogo: string | null;
  negativeLogoFileName: string | null;
  base64LoginImage: string | null;
  loginImageFileName: string | null;
  base64TermsAndConditions: string | null;
  base64TermsOfUse: string | null;
  base64ResourceLogo: string | null;
  resourceLogoFileName: string | null;
  resourceLogoAltText: string | null;
  resourceUrl: string | null;
}

export interface InputUpdateFileByVirtualPath {
  oldVirtualPath: string;
  newVirtualPath: string;
  data: string;
}

export interface InputUpdateFranchiseeDeploymentConfiguration {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
}

export interface InputUpdateFranchiseeSupplierProperties {
  deploymentFranchiseeConfigurationId: string;
  maxLicensePoolAllocation: number | null;
  primaryContact: BaseLogin | null;
  defaultV6Reference: string | null;
  primaryContactPhoneNumber: string | null;
  primaryContactEmail: string | null;
}

export interface InputUpdateSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeploymentId: number;
  referenceOverrides: { [key: string]: string } | null;
}

export interface InputUpdateSupportInboxItem {
  id: string;
  status: SupportInboxItemStatus | null;
  assignedUserId: string | null;
}

export interface InputUpdateSupportInboxItemForConversation {
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  quoteId: string;
  newQuoteId: string | null;
  conversationId: string;
  updatedByUserId: string;
  isUpdatedBySupplier: boolean;
  state: ConversationState | null;
  subject: string;
  ticketCreated: string;
}

export interface InputUpdateSupportInboxItemForQuoteReview {
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  branchId: string;
  quoteId: string;
  quoteSetId: string;
  status: SupportInboxItemStatus | null;
}

export interface InputUpdateTerritories {
  territories: Territory[];
}

export enum LicenseOwnerType {
  Internal = 0,
  Tenant = 1,
  Supplier = 2,
  Managed = 4
}

export interface PricingRule {
  id: string;
  supplierId: number;
  name: string;
  ruleTypeId: string;
  minValue: number;
  maxValue: number;
  minMarkup: number;
  maxMarkup: number;
}

export interface PricingRuleLibrary {
  pricingRules: PricingRule[];
  pricingRuleTypes: PricingRuleType[];
  defaultPricingRuleId: string;
}

export interface PricingRuleType {
  id: string;
  name: string;
  hasMinMax: boolean;
}

export interface PurchaseOrderAggregated {
  dateCreated: string;
  recordVersion: string;
  tenantId: number;
  supplierId: string;
  deploymentId: number;
  branchId: string;
  quoteId: string;
  id: string;
  title: string | null;
  purchaseOrderNumber: number;
  reference: string | null;
  state: number;
  installationDate: string | null;
  calculatedNettTotal: number;
  calculatedAdjustmentTotal: number;
  supplierSystemClosedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemStatus: string | null;
  tenantRecordVersion: string | null;
  assignedToUserId: string;
  creationUserId: string;
  lastModifiedUserId: string;
  dealerSystemDateCreated: string | null;
  dealerSystemLastModifiedDate: string | null;
  lastStateChangeDate: string | null;
  purchaseOrderCurrency: number;
}

export interface PurchaseOrderDTO {
  id: string;
  branchId: string;
  quoteId: string;
  title: string;
  purchaseOrderNumber: number;
  reference: string;
  state: number;
  installationDate: string | null;
  calculatedNettTotal: number;
  supplierSystemClosedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemStatus: string | null;
  calculatedAdjustmentTotal: number;
  recordVersion: string;
  assignedToUserId: string;
  creationUserId: string;
  lastModifiedUserId: string;
  dateCreated: string | null;
  lastModifiedDate: string | null;
  lastStateChangeDate: string | null;
  purchaseOrderCurrency: number;
}

export interface PurchaseOrderRecipient {
  id: string;
  email: string;
}

export interface PurchaseOrderRecipientLibrary {
  recipients: PurchaseOrderRecipient[];
}

export interface PurchaseOrderSummary {
  franchiseeTenantId: number;
  id: string;
  quoteId: string;
  branchId: string;
  title: string | null;
  purchaseOrderNumber: number;
  reference: string | null;
  installationDate: string | null;
  calculatedNettTotal: number;
  calculatedAdjustmentTotal: number;
  supplierSystemDeliveryDate: string | null;
  quoteNumber: number;
  quoteSuffix: string;
  supplierSystemStatus: string | null;
}

export interface QuoteAggregated {
  recordVersion: string;
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  dealerDeploymentId: number;
  branchId: string;
  id: string;
  quoteSetId: string;
  isPrimaryQuote: boolean;
  title: string | null;
  state: number;
  quoteNumber: number;
  quoteSuffix: string;
  quoteType: number;
  dateCreated: string;
  validUntilDate: string | null;
  installationDate: string | null;
  lastModifiedDate: string;
  lastModifiedUserId: string;
  tenantRecordVersion: string | null;
  calculatedNetTotal: number;
  creationUserId: string;
  assignedToUserId: string;
  lastStateChangeDate: string | null;
  quoteCurrency: number;
}

export interface QuoteDTO {
  id: string;
  quoteSetId: string;
  branchId: string;
  title: string;
  state: number;
  quoteType: number;
  quoteNumber: number;
  quoteSuffix: string;
  dateCreated: string;
  lastModifiedDate: string;
  lastModifiedUserId: string;
  creationUserId: string;
  validUntilDate: string | null;
  installationDate: string | null;
  recordVersion: string;
  calculatedNetTotal: number;
  assignedToUserId: string;
  isPrimaryQuote: boolean;
  lastStateChangeDate: string | null;
  quoteCurrency: number;
}

export enum QuoteType {
  None = 0,
  Estimate = 1,
  Quote = 2,
  Display = 4,
  Warranty = 8
}

export interface RequestCurrentRecordVersion {}

export interface RequestDataExportFranchisees {}

export interface RequestDataExportPurchaseOrders {
  pageSize: number | null;
  pageIndex: number | null;
  recordVersion: string | null;
}

export interface RequestDataExportQuotes {
  pageSize: number | null;
  pageIndex: number | null;
  recordVersion: string | null;
}

export interface RequestGetActiveUserInformation {
  systemUserId: string;
}

export interface RequestGetAllFranchiseeDetails {}

export interface RequestGetAllUserProfileOfTenant {}

export interface RequestGetConvertedQuoteTotals {
  startDate: string;
  endDate: string;
  branchIds: string[];
  userId: string;
}

export interface RequestGetFranchiseeDetails {
  deploymentFranchiseeConfigurationId: string;
}

export interface RequestGetGeneratedQuoteRevenue {
  startDate: string;
  endDate: string;
  branchIds: string[];
  assignedToUserId: string;
  states: number[];
}

export interface RequestGetLastRowVersion {
  franchiseeTenantId: number;
  globalSupplierSupplierId: string;
  deploymentId: number;
}

export interface RequestGetPurchaseOrderList {
  pageIndex: number;
  pageSize: number;
  sortField: string;
  sortAsc: boolean;
  branchId: string;
  assignedToUserId: string;
}

export interface RequestGetQuoteList {
  count: number;
  state: number;
}

export interface RequestGetResetTenantPassword {
  userName: string | null;
}

export interface RequestGetSupportInbox {
  requestPage: RequestPaginated;
  ticketOwnerFilter: SupportInboxTicketOwnerFilter;
  typeFilter: SupportInboxItemType;
  statusFilter: SupportInboxItemStatus;
  filter: string | null;
  sortField: string | null;
  sortAsc: boolean;
  branchIdFilter: string[] | null;
}

export interface RequestGetTerritorySummary {}

export interface RequestGetUserProfile {
  systemUserIds: string[] | null;
}

export interface RequestLicenseServerNotify {
  command: string;
  information: { [key: string]: string };
}

export interface RequestOnBoardTenant {
  companyName: string | null;
  businessPhone: string | null;
  reference: string | null;
  licensePoolId: number;
  licenseAllocation: number;
  deploymentId: number;
  initialUserName: string | null;
  initialUserEmail: string | null;
  initialName: string | null;
  initialPhone: string | null;
  initialJobTitle: string | null;
}

export interface RequestPAT {
  dealerDeploymentId: number;
  tenantId: number;
  preferredLifeOfTokenHours: number | null;
  claims: { [key: string]: string } | null;
}

export interface RequestPaginated {
  pageSize: number;
  pageIndex: number;
}

export interface RequestSupplierGetGeneratedPurchaseOrderRevenue {
  startDate: string;
  endDate: string;
  branchIds: string[];
  assignedToUserId: string;
  states: number[];
}

export interface RequestSystemConfiguration {}

export interface ResetTenantMigrationCheckRequest {
  tenantId: number;
}

export interface ResultAddQuoteSupportRequest {
  supplierSupportInboxItem: SupplierSupportInboxItem;
  state: AddQuoteSupportRequestState;
}

export interface ResultCopyFilesByVirtualPath {}

export interface ResultCreateFranchisee {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
}

export interface ResultCreateTerritory {
  territory: Territory;
}

export interface ResultCurrentRecordVersion {
  recordVersion: string;
}

export interface ResultDataExportFranchisees {
  deployments: ViewDeploymentExport[];
  supplierUsers: ViewSupplierUserExport[];
}

export interface ResultDataExportPurchaseOrders {
  purchaseOrders: PurchaseOrderAggregated[];
}

export interface ResultDataExportQuotes {
  quotes: QuoteAggregated[];
}

export interface ResultDeleteFilesByVirtualPath {}

export interface ResultDeleteSupplierImages {
  supplierSettings: SupplierSettings;
}

export interface ResultDeleteTerritory {}

export interface ResultGetActiveUserInformation {
  globalSupplier: GlobalSupplierReference;
  userClaims: { [key: string]: string };
}

export interface ResultGetAllFranchiseeDetails {
  tenantList: ResultTenantList;
  franchisees: DeploymentFranchiseeConfiguration[];
  branches: DeploymentFranchiseeBranch[];
  branchReferences: ResultGetSupplierReferenceCodeOnTenant[];
}

export interface ResultGetAllUserProfileOfTenant {
  userProfiles: TenantLoginPublicInfo[] | null;
}

export interface ResultGetConvertedQuoteTotals {
  quoteCount: number;
  purchaseOrderCount: number;
}

export interface ResultGetCoreSupplierSettings {
  allSettings: AllSupplierSettings;
}

export interface ResultGetFranchiseeDetails {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
  tenantList: ResultTenantList;
  branches: DeploymentFranchiseeBranch[];
}

export interface ResultGetGeneratedPurchaseOrderRevenue {
  revenueSummary: ViewDailyRevenueByCurrency[];
  startDate: string;
  endDate: string;
  purchaseOrderStates: number[];
}

export interface ResultGetGeneratedQuoteRevenue {
  revenueSummary: ViewDailyRevenueByCurrency[];
  startDate: string;
  endDate: string;
  states: number[];
}

export interface ResultGetLastRowVersion {
  quoteRowVersion: string;
  purchaseOrderRowVersion: string;
  quoteOwnerIds: string[];
}

export interface ResultGetPurchaseOrderList {
  purchaseOrders: PurchaseOrderSummary[];
  totalCount: number;
}

export interface ResultGetQuoteList {
  quotes: QuoteAggregated[];
}

export interface ResultGetResetTenantPassword {}

export interface ResultGetSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeplymentId: number;
  referenceOverrides: { [key: string]: string } | null;
}

export interface ResultGetSupportInbox {
  items: ViewSupportInboxItemExResultPaginated;
}

export interface ResultGetTerritorySummary {
  territories: Territory[];
  territoryFranchiseBranches: TerritoryFranchiseeBranchLink[];
}

export interface ResultGetUserProfile {
  userProfiles: TenantLoginPublicInfo[] | null;
}

export interface ResultLicenseServerNotify {}

export interface ResultLinkFranchiseeBranchToTerritory {
  territoryFranchiseeBranchLinks: TerritoryFranchiseeBranchLink[];
}

export interface ResultPAT {
  pat: string | null;
}

export interface ResultSetNewQuotesAndPurchaseOrdersForSupplier {
  quotesUpdated: number;
  purchaseOrdersUpdated: number;
}

export interface ResultSupplierSystemConfiguration {
  supplierQuoteItemConfigurations: SupplierQuoteItemTableConfiguration[];
}

export interface ResultSyncBranches {}

export interface ResultTenantList {
  deployments: ViewDeploymentTenants[] | null;
  tenants: Tenant[] | null;
  globalSupplierSupplierId: string;
  globalSupplierId: number;
}

export interface ResultUnlinkFranchiseeBranchFromTerritory {}

export interface ResultUpdateCoreSupplierSettings {
  settings: AllSupplierSettings;
}

export interface ResultUpdateFileByVirtualPath {
  virtualPath: string | null;
  eTag: string | null;
  lastModified: string | null;
  contentType: string | null;
  contentLength: number | null;
}

export interface ResultUpdateFranchiseeDeploymentConfiguration {
  deploymentFranchiseeConfiguration: DeploymentFranchiseeConfiguration;
}

export interface ResultUpdateFranchiseeSupplierProperties {}

export interface ResultUpdateSupplierReferenceCodeOnTenant {}

export interface ResultUpdateSupportInboxItem {
  supplierSupportInboxItem: SupplierSupportInboxItem;
  viewSupportInboxItem: ViewSupportInboxItemEx;
}

export interface ResultUpdateTerritories {
  territories: Territory[];
}

export interface ResultVerifyUser {
  claims: { [key: string]: string } | null;
}

export interface ResultVoid {}

export interface SupplierQuoteItemTableConfiguration {
  code: string;
  title: string;
  systemDefault: boolean;
  defaultDisplay: boolean;
  canSwitch: boolean;
}

export interface SupplierSettings {
  lastModifiedUserId: string | null;
  lastModifiedUtc: string | null;
  rowVersion: string | null;
  id: string;
  globalSupplierId: number;
  positiveLogoVirtualPath: string;
  negativeLogoVirtualPath: string;
  loginImageVirtualPath: string;
  allowCustomItem: boolean;
  allowSupportRequest: boolean;
  allowSupplierReview: boolean;
  allowedQuoteTypes: QuoteType[];
  validityPeriod: number;
  leadPeriod: number;
  removeWatermarkOnDraft: boolean;
  watermark: WatermarkType;
  termsAndConditionsVirtualPath: string;
  termsOfUseVirtualPath: string;
  purchaseOrderRecipientsVirtualPath: string;
  pricingRulesVirtualPath: string;
  willCallLocations: WillCallLocation[] | null;
  quoteItemTableConfiguration: SupplierTableConfig[] | null;
  resourceLogoVirtualPath: string;
  resourceLogoAltText: string;
  resourceUrl: string;
}

export interface SupplierSupportInboxItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  globalSupplierReferenceId: string;
  dealerDeploymentId: number;
  franchiseeTenantId: number;
  conversationId: string;
  branchId: string;
  quoteId: string;
  quoteSetId: string;
  franchiseeSystemUserId: string;
  type: SupportInboxItemType;
  status: SupportInboxItemStatus;
  lastModified: string;
  lastModifiedUserId: string;
  assignedToUserDateTime: string | null;
  assignedUserId: string;
  subject: string;
  note: string | null;
  other: { [key: string]: string };
}

export interface SupplierTableConfig {
  code: string;
  title: string;
  systemDefault: boolean;
  defaultDisplay: boolean;
  canSwitch: boolean;
}

export interface SupplierTenantInfo {
  tenantId: number;
  allowSupplierSupportAccess: boolean;
  reference: string | null;
  licensePoolAllocations: number;
  licensePoolAllocated: number;
  state: TenantInitializationState;
  primaryContact: BaseLogin | null;
}

export enum SupportInboxItemStatus {
  All = 0,
  New = 1,
  Overdue = 2,
  Active = 4,
  Resolved = 8,
  Cancelled = 16,
  ReActivated = 32
}

export enum SupportInboxItemType {
  All = 0,
  Basic = 1,
  QuoteReview = 2,
  EngineeredToOrder = 4,
  QuoteAssistanceRequest = 8
}

export enum SupportInboxTicketOwnerFilter {
  All = 0,
  Mine = 1,
  Unassigned = 2
}

export interface SystemViewLicensePool {
  licensePool: DeploymentTenantLicensePool | null;
  availableUsers: number;
  availableAllocations: number;
}

export interface Tenant {
  dateCreated: string;
  id: number;
  recordVersion: string | null;
  companyName: string | null;
  primaryContact: string | null;
  primaryContactPhoneNumber: string | null;
  primaryContactEmail: string | null;
  claims: { [key: string]: string } | null;
  onboardedBySupplierId: number | null;
}

export enum TenantInitializationState {
  Available = 0,
  RequestedBySupplier = 1,
  PendingDelivery = 2,
  Disabled = 4
}

export interface TenantLoginPublicInfo {
  id: string;
  tenantId: number;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  jobTitle: string | null;
  phone: string | null;
}

export interface Territory {
  dateCreated: string;
  id: string;
  recordVersion: string;
  name: string;
  supplierId: string;
}

export interface TerritoryFranchiseeBranchLink {
  dateCreated: string;
  id: string;
  recordVersion: string;
  territoryId: string;
  branchId: string;
}

export enum TestExceptionType {
  Generic = 0,
  Authentication = 1,
  Authorization = 2,
  AlreadyConnected = 3,
  MigrationError = 4,
  RetryLimitExceeded = 5,
  Validation = 6,
  ModifyNotFound = 7,
  ServiceResponse = 8,
  HttpRequest = 9,
  DeeplyNested = 10,
  Aggregate = 11
}

export interface TestPingResponse {
  message: string;
  timestamp: string;
}

export interface ViewDailyRevenueByCurrency {
  count: number;
  date: string;
  state: number;
  dailyRevenue: number;
  currency: CurrencyCode;
}

export interface ViewDeploymentExport {
  dealerDeploymentId: number;
  dealerDeploymentName: string;
  uiDomain: string;
  franchisees: ViewFranchiseeExport[];
}

export interface ViewDeploymentTenants {
  dealerDeploymentId: number;
  name: string | null;
  uiDomain: string | null;
  tenants: SupplierTenantInfo[] | null;
  userLoginInformation: ViewUserLoginInformation[] | null;
  licensePools: SystemViewLicensePool[] | null;
}

export interface ViewFranchiseeBranchExport {
  name: string;
  abbreviation: string;
  physicalAddress: Address | null;
  billingAddress: Address | null;
  v6CustomerCode: string;
  id: string;
}

export interface ViewFranchiseeExport {
  id: number;
  name: string;
  defaultV6CustomerCode: string;
  branches: ViewFranchiseeBranchExport[];
  users: ViewSystemUserExport[];
  licensesProvided: number;
  licensesUsed: number;
}

export interface ViewSupplierUserExport {
  systemUserId: string;
  userName: string;
  displayName: string;
  emailAddress: string;
}

export interface ViewSupportInboxItemEx {
  item: SupplierSupportInboxItem;
  title: string | null;
  state: number;
  quoteNumber: number;
  quoteSuffix: string;
  quoteType: number;
  quoteLastModified: string;
  quoteLastModifiedUserId: string;
  quoteAssignedToUserId: string;
}

export interface ViewSupportInboxItemExResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewSupportInboxItemEx[];
}

export interface ViewSystemUserExport {
  systemUserId: string;
  userName: string;
  displayName: string;
  emailAddress: string;
  active: boolean;
  lastLoginTime: string | null;
  branchAccess: string[];
  isAdmin: boolean;
  isPrimaryContact: boolean;
  isBranchAdmin: boolean;
  canAccessAllBranches: boolean;
}

export interface ViewUserLoginInformation {
  tenantId: number;
  tenantLoginId: number;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  active: boolean;
  lastLoginTime: string | null;
  claims: { [key: string]: string } | null;
  systemUserId: string;
}

export enum WatermarkType {
  DraftInternalRed = 0,
  DraftInternal = 1,
  InternalUse = 2,
  Draft = 4,
  DraftVersion = 8
}

export interface WillCallAddress {
  line1: string;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export interface WillCallLocation {
  id: string;
  title: string;
  type: string;
  willCallAddress: WillCallAddress;
}
